import { render } from "./InboxContent.vue?vue&type=template&id=39fa27f8"
import script from "./InboxContent.vue?vue&type=script&lang=js"
export * from "./InboxContent.vue?vue&type=script&lang=js"

import "./InboxContent.vue?vue&type=style&index=0&id=39fa27f8&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__